import React, { useEffect, useReducer, useState } from 'react';
import LoadingWrapper from 'components/loading/LoadingWrapper';
import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import { Card } from 'react-bootstrap';
import TableHeader from 'components/common/TableHeader';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import { useQuery } from 'react-query';
import { getCounting } from 'services/warehouse';
import { queryReducer } from 'reducers/queryReducer';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import SoftBadge from 'components/common/SoftBadge';
import { statusOptions } from './module/Static';

const CountingList = () => {
  const [queryObj, setQueryObj] = useState({
    limit: 10,
    offset: 0
  });
  const [sort, setSort] = useState({
    direction: 'none',
    accessor: ''
  });
  const navigate = useNavigate();
  const { isLoading, data } = useQuery(
    ['countinglist', queryObj, sort],
    () =>
      getCounting({
        ...queryObj,
        ordering:
          sort.direction !== 'DESC' ? sort.accessor : '-' + sort.accessor
      }),
    {
      keepPreviousData: true
    }
  );
  const [{ pageIndex, pageSize, totalCount }, dispatch] = useReducer(
    queryReducer,
    { pageIndex: 0, pageSize: 10, totalCount: data?.data.count }
  );
  useEffect(() => {
    setQueryObj({
      ...queryObj,
      limit: pageSize,
      offset: pageSize * pageIndex
    });
  }, [pageSize, pageIndex, totalCount]);

  useEffect(() => {
    if (!data?.data.count) return;
    dispatch({
      type: 'TOTAL_COUNT_CHANGED',
      payload: data?.data.count
    });
  }, [data?.data.count]);

  const columns = [
    {
      accessor: 'id',
      Header: 'ID',
      headerProps: { className: 'pe-1 text-start' },
      cellProps: {
        className: 'py-2'
      },
      Cell: rowData => {
        const { id } = rowData.row.original;
        return <Link to={`/stock/counting-detail/${id}`}>{id}</Link>;
      },
      disableSortBy: true
    },
    {
      accessor: 'date',
      Header: 'Date',
      headerProps: { className: 'pe-1 text-center' },
      cellProps: {
        className: 'py-2 text-center'
      },
      Cell: rowData => {
        const { date } = rowData.row.original;
        return moment(date).format('DD/MM/YYYY');
      }
    },
    {
      accessor: 'storageLocation__name',
      Header: 'Warehouse',
      headerProps: { className: 'pe-1 text-center' },
      cellProps: {
        className: 'py-2 text-center'
      },
      Cell: rowData => {
        const { storageLocation } = rowData.row.original;
        return storageLocation?.name;
      }
    },
    {
      accessor: 'product_type_quantity',
      Header: 'Product Type Quantity',
      headerProps: { className: 'pe-1 text-center' },
      cellProps: {
        className: 'py-2 text-center'
      },
      disableSortBy: true
    },
    {
      accessor: 'product_quantity',
      Header: 'Product Quantity',
      headerProps: { className: 'pe-1 text-center' },
      cellProps: {
        className: 'py-2 text-center'
      },
      disableSortBy: true
    },
    {
      accessor: 'status',
      Header: 'Status',
      cellProps: { className: 'text-center' },
      Cell: rowData => {
        const { status } = rowData.row.original;
        return (
          <SoftBadge
            pill
            bg={statusOptions.filter(e => e.value === status)[0].bg}
            className="d-block"
          >
            {statusOptions.filter(e => e.value === status)[0].label}
          </SoftBadge>
        );
      }
    }
  ];

  const handleNew = () => {
    navigate('/stock/counting-add');
  };

  return (
    <LoadingWrapper loading={isLoading}>
      <AdvanceTableWrapper
        columns={columns}
        data={data?.data.results || []}
        sortable
        pagination
        queryPageIndex={pageIndex}
        totalCount={totalCount}
        dispatch={dispatch}
      >
        <Card className="mb-3">
          <Card.Header>
            <TableHeader
              title="Counting List"
              isBulkAction={false}
              handleNew={handleNew}
              table
            />
          </Card.Header>
          <Card.Body className="p-0">
            <AdvanceTable
              table
              headerClassName="bg-200 text-900 text-nowrap align-middle text-center"
              rowClassName="align-middle"
              tableProps={{
                size: 'sm',
                striped: true,
                className: 'fs--1 mb-0'
              }}
              sort={sort}
              setSort={setSort}
            />
          </Card.Body>
          <Card.Footer>
            <AdvanceTablePagination table />
          </Card.Footer>
        </Card>
      </AdvanceTableWrapper>
    </LoadingWrapper>
  );
};

export default CountingList;
